module.exports = __webpack_public_path__ + "static/media/flow-online.f0e767d9.svg";